import _ from 'underscore';

export const openOldUI = (scope, getPath) => {
  const path = _.isFunction(getPath)
    ? getPath(scope)
    : getPath;

  window.open(path);
};
